const workTypeColumns = [
  {
    title: "Registration type on SF4C",
    dataIndex: "sf4c_registration_type",
    width: "20%",
    type: "text",
    scopedSlots: { customRender: "category" },
  },
  {
    title: "Definition",
    dataIndex: "tms_definition",
    width: "20%",
    type: "text",
    scopedSlots: { customRender: "description" },
  },
  {
    title: "SF4C notation",
    dataIndex: "sf4c_notation",
    width: "20%",
    type: "text",
    scopedSlots: { customRender: "sf4c_notation" },
  },
  {
    title: "TMS-Payroll notation",
    dataIndex: "tms_notation",
    width: "20%",
    type: "text",
    scopedSlots: { customRender: "code" },
  },
];
const workPeriodColumns = [
  {
    title: "From Date - To Date",
    dataIndex: "from_date",
    type: "fromDate",
    scopedSlots: { customRender: "from_date" },
  },
  {
    title: "Standard working days",
    dataIndex: "working_days",
    type: "text",
  },
  {
    title: "Timesheets",
    dataIndex: "timesheet",
    type: "text",
    scopedSlots: { customRender: "timesheet" },
  },
  {
    title: "Payroll",
    dataIndex: "",
    type: "text",
    scopedSlots: { customRender: "payroll" },
  },
  {
    title: "Lock",
    dataIndex: "is_lock",
    type: "checkbox",
    scopedSlots: { customRender: "is_lock" },
  },
  {
    title: "Company",
    dataIndex: "company_id",
    width: "15%",
    type: "text",
  },
];

const projectColumns = [
  {
    title: "Department",
    dataIndex: "department",
    width: "150px",
    type: "text",
  },
  {
    title: "Project ID",
    dataIndex: "project_id",
    type: "render",
    width: "150px",
    renderFunc: (record) => {
      console.log("record :" + JSON.stringify(record))
      const projectID = record?.project_id && record?.project_id.length > 0 ? record.project_id : '';
      const maxLength = 10;
      return projectID.length > maxLength ? projectID.substring(0, maxLength) + " ... " : projectID;
    },
    renderTooltipFunc:(record) => {
      return record?.project_id && record?.project_id.length > 0 ? record.project_id : '';
    },    
    isShowTooltip: true,
    scopedSlots: { customRender: "project_id" },    
  },
  {
    title: "Project Name",
    dataIndex: "project_name",
    width: "250px",
    type: "render",
    renderFunc: (record) => {
      const projectName = record?.project_name && record?.project_name.length > 0 ? record.project_name : '';
      const maxLength = 20;
      return projectName.length > maxLength ? projectName.substring(0, maxLength) + " ... " : projectName;
    },
    renderTooltipFunc:(record) => {
      return record?.project_name && record?.project_name.length > 0 ? record.project_name : '';
    },
    isShowTooltip: true,
    scopedSlots: { customRender: "project_name" },
  },
  {
    title: "Start Date - End Date",
    dataIndex: "start_end_date",
    width: "200px",
    type: "render",
    renderFunc: (record) => {
      if (!record?.start_date && !record?.end_date) return ''
      return (record?.start_date ? formatDate(record?.start_date) : record?.start_date || null) + " → " + (record?.end_date ? formatDate(record?.end_date) : record?.end_date || null)
    },
    isShowTooltip: false,
    scopedSlots: { customRender: "start_end_date" },
  },
  {
    title: "Project Manager",
    dataIndex: "pms",
    type: "render",
    renderFunc: (record) => {
      const managers = record?.pms && record?.pms.length > 0 ? record.pms.map((item) => `${item.pm_full_name} (${item.pm_user_name})` ).join(', ') : '';
      const maxLength = 100;
      return managers.length > maxLength ? managers.substring(0, maxLength) + " ... " : managers;
    },
    renderTooltipFunc:(record) => {
      return record?.pms && record?.pms.length > 0 ? record.pms.map((item) => `${item.pm_full_name} (${item.pm_user_name})` ).join(', ') : '';
    },
    isShowTooltip: true,
    scopedSlots: { customRender: "pms" },
  },
  {
    title: "Members",
    dataIndex: "resources",
    width: "100px",
    type: "render",
    renderTooltipFunc: (record) => {
      return record.resources && record?.resources.length > 0 ? record.resources.map((item) => `${item.rs_full_name} (${item.rs_user_name})` ).join(', ') : '';
    },
    renderFunc: (record) => {
      return record.resources && record?.resources.length || 0;
    },
    isShowTooltip: true,
    scopedSlots: { customRender: "resources" },
  },
  {
    title: "Action",
    width: "15%",
    dataIndex: 'action',
    type: "action",
    scopedSlots: { customRender: "action" },
  },
];

const formatDate = (date) => {
  return moment(date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
}

import EditingTable from "./EditingTable/EditingTable.vue";
import CreateEditProjectModal from "./CreateEditProjectModal/CreateEditProject.vue";
import AddMemberModal from "./AddMemberModal/AddMember.vue";
import { scaleScreen, convertObjectToParams } from "../../components/commons/commons";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "Settings",
  components: { EditingTable, CreateEditProjectModal, AddMemberModal },
  data() {
    return {
      workTypeColumns: workTypeColumns,
      workPeriodColumns: workPeriodColumns,
      workTypeList: [],
      payrollPeriodList: [],
      currentTab: "work_type",
      field: "code",
      direction: "DESC",
      total_element_period: 0,
      total_element_workType: 0,
      //add member to project
      total_project_period: 0,
      isLoading: false,
      projectColumns: projectColumns,
      projectList: [],
      isEdit: false,
      visibleModal: false,
      dataRecordEdit: {},
      visibleModalAddMember: false,
      urlProject: '',
      formSearch: {
        pms: [],
        projectName: '',
        department: ''
      },
      listDepartment: [],
      pageStr: '',
      pageSizeStr: '',
    };
  },
  computed: {
    ...mapState({
      loading: (state) => state.user.loading,
      employeeList: (state) => state.application.employeeList,
      departmentList: (state) => state.application.departmentList,
    }),
  },
  watch: {
    departmentList (newValue) {
      this.listDepartment = newValue
    }

  },
  created() {
    this.onHandleGetListDepartment()
    this.scaleScreen();
    if (this.currentTab === "work_type") {
      this.getWorkTypeList();
    } else if (this.currentTab === "payroll_period"){
      this.getPayrollPeriodList();
    } else {
      this.getProjectList()
    }
  },
  methods: {
    scaleScreen,

    onHandleGetListDepartment() {
      this.$store
        .dispatch("application/getDepartmentList")
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSearchDepartment (value) {
      this.listDepartment = this.departmentList.filter(item => {
        return item.name.toLowerCase().indexOf(value.toLowerCase()) >= 0 || ( item.department_code.toLowerCase().indexOf(value.toLowerCase()) >= 0)
      })
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      this.isLoading = true;
      clearTimeout(this.timeoutAllStaff);
      this.timeoutAllStaff = setTimeout(() => {
        this.$store
          .dispatch("application/getEmployeeList", cloneVal)
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }, timeout);
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onSelectTab(key) {
      if (key == "work_type") {
        this.getWorkTypeList();
      }
      if (key == "payroll_period") {
        this.getPayrollPeriodList();
      }

      if (key == "member_to_project") {
        this.getProjectList();
        this.formSearch = {
          pms: [],
          projectName: '',
          department: ''
        }
      }
      this.currentTab = key;
    },

    onSearchProject(page = 1, pageSize = 10) {
      this.pageStr = page;
      this.pageSizeStr = pageSize;
      let payloadSearch = {
        page: this.pageStr,
        size: this.pageSizeStr
      };
      if (this.formSearch.pms.length > 0) {
        payloadSearch = {
          ...payloadSearch,
          pms: this.formSearch.pms.toString()
        } 
      }
      if (this.formSearch.department) {
        payloadSearch = {
          ...payloadSearch,
          departments: this.formSearch.department.trim()
        } 
      }
      if (this.formSearch.projectName) {
        payloadSearch = {
          ...payloadSearch,
          projectName: this.formSearch.projectName.trim()
        }
      }
      
      const url = convertObjectToParams(payloadSearch);
      this.getProjectList(url)
    },

    changePage({ page, pageSize }) {
      this.pageStr = page;
      this.pageSizeStr = pageSize;
    },

    //Function get list of work type
    getWorkTypeList(url) {
      this.$store.dispatch("user/loadingRequest");
      if (url === undefined) {
        url = "";
      }
      this.$store
        .dispatch("settings/getWorkTypeList", url)
        .then((res) => {
          let data = [];
          if (res && res.data) {
            data = res.data.map((item, index) => {
              item.key = index;
              return item;
            });
            this.total_element_workType = res.page;
          } else if (res.message !== null && res.message !== "") {
            this.$message.error(res.message, 5);
          }
          this.$set(this.$data, "workTypeList", data);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },

    //Function get list of payroll periods
    getPayrollPeriodList(url) {
      this.$store.dispatch("user/loadingRequest");
      if (url === undefined) {
        url = "";
      }
      this.$store
        .dispatch("settings/getPayrollPeriodList", url)
        .then((res) => {
          let data = [];
          if (res && res.data) {
            data = res.data.map((item, index) => {
              item.key = index;
              return item;
            });
            this.total_element_period = res.page;
          } else if (res.message !== null && res.message !== "") {
            this.$message.error(res.message, 5);
          }
          this.$set(this.$data, "payrollPeriodList", data);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    getProjectList (url) {
      this.$store.dispatch("user/loadingRequest");
      if (url === undefined) {
        url = "";
      }
      this.urlProject = url;
      this.$store
        .dispatch("settings/getProjectSettingList", url)
        .then((res) => {
          let data = [];
          if (res && res.data) {
            data = res.data.map((item, index) => {
              item.key = index;
              return item;
            });
            this.total_project_period = res.page;
          } else if (res.message !== null && res.message !== "") {
            this.$message.error(res.message, 5);
          }
          this.$set(this.$data, "projectList", data);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    //Project Start
    onHandleAddNewProject() {
      this.visibleModal = true
      this.isEdit = false
    },
    handleCancel () {
      this.visibleModal = false
      this.isEdit = false
    },
    handleCancelMember () {
      this.visibleModalAddMember = false
    },
    onShowModalAddMember (value) {
      this.visibleModalAddMember = true
      this.dataRecordEdit = value
    },
    onShowModalEdit (value) {
      this.visibleModal = true
      this.isEdit = true
      this.dataRecordEdit = value
    },
    onShowDelete (value) {
      this.$confirm({
        title: "Confirm",
        content: "Do you want to delete this Project?",
        okText: "Yes",
        onOk: () => {
          this.deleteProject(value);
        },
        cancelText: "No",
      });
    },
    onOKAddProject(payload) {
      this.$store
        .dispatch("settings/addProject", payload)
        .then(() => {
          this.handleCancel();
          this.$message.success("Create Project successfully !");
          this.getProjectList(this.urlProject);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message || err.message, 5);
        });
    },
    onOKEditProject(payload) {
      this.$store
        .dispatch("settings/editProject", payload)
        .then(() => {
          this.handleCancel();
          this.$message.success("Edit Project successfully !");
          this.getProjectList(this.urlProject);
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },

    deleteProject (value) {
      this.$store
        .dispatch("settings/deleteProject", value.id)
        .then(() => {
          this.handleCancel();
          this.$message.success("Delete Project successfully !");
          this.getProjectList(this.urlProject);
        })
        .catch((err) => {
          this.$message.error(err.message, 5);
        });
    },

    handleGetListProject () {
      this.onSearchProject(this.pageStr, this.pageSizeStr)
    },
    //Project End
    cancelWorkTypeSubmit() {
      this.getWorkTypeList();
    },
    myFunction() {
      document.body.style.position = "absolute";
    },
    handleSearchOnEnter(){
      this.onSearchProject(1, 10)
    }
  },
  mounted() {
    this.myFunction();
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
};
